import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireRole } from '../../lib/auth/guards';

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async ({ context, location }) => {
    await requireRole(context.queryClient, location.pathname, 'admin');
  },
  component: () => <Outlet />,
});
